import { useEffect, useRef, useState } from "react";
import infoCircle from "../assets/info-circle.svg";
import dots from "../assets/verticle-dots.svg";
import add from "../assets/plus-blue.svg";
import cross from "../assets/black-cross.svg";
import CommonModal from "../components/CommonModal";
import SwitchToggle from "./switch";
import { fetchLanguageList, fetchRegionList } from "../action/page";
import { toast } from "react-toastify";
import inputbadge from "../assets/pen1.svg";
import DeleteModal from "./DeleteModal";

// const NavigationRegionSpecific = ({siblings}) => {
const NavigationRegionSpecific = ({ siblings, onEditRegion, onAddRegion, onDeleteRegion }) => {
    const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
    const [showRegionModal, setShowRegionModal] = useState(false);
    const dropdownRef = useRef(null);
    const [regions, setRegions] = useState([]);
    const [languages, setLanguages] = useState([]);
    const [loadingLists, setLoadingLists] = useState(false);
    const [selectedRegion, setSelectedRegion] = useState("");
    const [selectedLanguage, setSelectedLanguage] = useState("");
    const [selectedSibling, setSelectedSibling] = useState("en");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deletingSibling, setDeletingSibling] = useState("");

    const addedLocales = siblings?.map(s => s.locale).filter(Boolean) || [];
    const remainingLanguages = languages.filter(l => !addedLocales.includes(l.slug));

     const loadLists = async () => {
        setLoadingLists(true);
        const r = await fetchRegionList();
        const l = await fetchLanguageList();
        const regionList = r?.data?.list || [];
        setRegions(regionList);
        setLanguages(l?.data?.list || []);
        if (regionList.length > 0) {
          setSelectedRegion(regionList[0]._id);
        }
        setLoadingLists(false);
      };


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpenDropdownIndex(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <>
            <div className="mb-4 pb-4 br-btm">
                <div className="card-title pb-1 d_flex">
                    Region Specific Content
                </div>
                <div ref={dropdownRef}>
                    {siblings && siblings?.map((r, index) => {
                    const isEditing = selectedSibling === r.locale;
                        return (
                            <div key={index} className="coutry-fields" style={{ position: "relative" }} ref={dropdownRef}>
                                <div className="input-with-icon right mt-3">
                                {isEditing && (
                  <div className="input_badge">
                    <img src={inputbadge} alt="icon" />
                    <span className="field-label">Editing</span>
                  </div>
                )}
                                    <input
                                        type="text"
                                        className="frm-input"
                                        value={r.locale}
                                        readOnly
                                    />

                                    <img
                                        src={dots}
                                        className="input-icon pointer"
                                        alt="dots"
                                        onClick={() =>
                                            setOpenDropdownIndex(
                                                openDropdownIndex === index ? null : index
                                            )
                                        }
                                    />
                                </div>

                                {openDropdownIndex === index && (
                                    <div className="region-dropdown-menu"
                                        onMouseDown={(e) => e.stopPropagation()}
                                    >
                                        <div className="dropdown-item"
                                            onClick={(e) => {
                                                e.stopPropagation(); // 🔥 IMPORTANT
                                                onEditRegion(r.locale, r.is_default);
                                                setSelectedSibling(r.locale)
                                                setOpenDropdownIndex(null);
                                            }}
                                        >
                                            Edit Regional Content
                                        </div>
                                      {!r.is_default && (
  <div
    className="dropdown-item delete"
    onClick={(e) => {
        e.stopPropagation();
        setShowDeleteModal(true);
        setDeletingSibling(r.locale);
      setOpenDropdownIndex(null);
    }}
  >
    Delete Version
  </div>
)}
                                    </div>
                                )}
                            </div>
                        )
                    }
                    )}
                    </div>

                <div className="addmore pt-3">
                    <button
                        className="add-blue-link"
                        onClick={() => {
                            loadLists();
                            setShowRegionModal(true);
                          }}
                    >
                        <img src={add} alt="add" /> Add New Language
                    </button>
                </div>
            </div>

            {showRegionModal && (
                <CommonModal
                    show={showRegionModal}
                    onClose={() => setShowRegionModal(false)}
                    width="500px"
                >
                     <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            fontSize: 20,
                            fontWeight: 600,
                            marginBottom: 10
                        }}
                    >
                        Select Language
                        <img
                            src={cross}
                            alt="close"
                            className="pointer"
                            onClick={() => setShowRegionModal(false)}
                        />
                    </div>

                    <p className="modal-subtitle">
                        Choose the language you want to create localized navigation for.
                    </p>

                    <label className="frm-label mt-3">Select Language</label>
                    <select
            className="frm-input"
            value={selectedLanguage}
            disabled={loadingLists}
            onChange={(e) => setSelectedLanguage(e.target.value)}
          >
            {loadingLists ? (
              <option>Loading languages...</option>
            ) : (
              <>
                <option value="">Choose language</option>
                {remainingLanguages.map((l) => (
                  <option key={l._id} value={l._id}>
                    {l.name}
                  </option>
                ))}
              </>
            )}
                    </select>
                    
                    <div className="modal-actions mt-4">
                        <button
                            className="btn-white"
                            onClick={() => setShowRegionModal(false)}
                        >
                            Cancel
                        </button>

                        <button
                            className="btn-black"
                            // onClick={() => setShowRegionModal(false)}
                            onClick={() => {
                                const regionObj = regions.find(r => r._id === selectedRegion);
                                const langObj = languages.find(l => l._id === selectedLanguage);
                                if (!regionObj || !langObj) return;
                                const localeKey = langObj.slug;
                                // 🔴 VALIDATION: already exists
                                const alreadyExists = siblings?.some(s => s.locale === localeKey);
                                if (alreadyExists) {
                                            toast.error("Menu already exists for this language");
                                  return;
                                }
                              
                                // ✅ Add new region
                                onAddRegion({
                                  locale: localeKey,
                                    is_default: false,
                                    language: {
                                        name:langObj.name,
                                        _id:langObj._id
                                    },
                                    region: {
                                        name:regionObj.name,
                                        _id:regionObj._id
                                    }
                                });
                                setShowRegionModal(false);
                                setSelectedRegion("");
                                setSelectedLanguage("");
                              }}
                        >
                            Confirm
                        </button>
                    </div>
                </CommonModal>
            )}
             <DeleteModal
                    show={showDeleteModal}
                onClose={() => {
                    setDeletingSibling("");
                    setShowDeleteModal(false);
                }}
                onDelete={() => {
                    onDeleteRegion(deletingSibling);
                    setShowDeleteModal(false)
                }}
                  />
        </>
    );
};

export default NavigationRegionSpecific;